import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

export const LoggingIn: React.FC = () => {
  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Access a Shared Resource</DialogTitle>
      <DialogContent>
        <p>Please check your emails</p>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
};
